import { NgModule } from '@angular/core';

// Modules
import { SharedModule } from '../../shared/shared.module';
import { CamtlMaintenanceModule } from './administration/maintenance/maintenance.module';
import { CamtlSecurityModule } from './administration/security/security.module';
import { CamtlReportsModule } from './administration/reports/reports.module';
import { CamtlContactsModule } from './camtl-contacts/camtl-contacts.module';
import { CamtlMasterToolListModule } from './master-tool-list/master-tool-list.module';

// ToolTypeService
import { ParameterManagementTypeService } from './parameter-management/tooltype.service';

// Components
import { CamtlComponent } from './camtl.component';
import { CamtlAdministrationComponent } from './administration/administration.component';
import { SystemSelectComponent } from './system-select/system-select.component';
import { TimingChartsComponent } from './timing-charts/timing-charts.component';
import { FunctionalViewComponent } from './timing-charts/functional-view/functional-view.component';
import { WorkflowInboxComponent } from './workflow/workflow-inbox.component';
import { ApprovalComponent } from './approval/approval.component';


import { ParameterManagementComponent } from './parameter-management/parameter-management.component';
import { ParameterTabsComponent } from './parameter-tabs/parameter-tabs.component';
import { ControlPanelComponent } from './parameter-management/control-panel/control-panel.component';
import { FurnishedEquipmentComponent } from './parameter-management/furnished-equipment/furnished-equipment.component';
import { KitComponent } from './parameter-management/kit/kit.component';
import { ToolComponent } from './parameter-management/tool/tool.component';
import { WeldgunComponent } from './parameter-management/weldgun/weldgun.component';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

// Providers
import { SystemSelectService } from './system-select/system-select.service';
import {
    CamtlBaseService,
    ContactService,
    FunctionService,
    FunctionalViewService,
    FunctionContactService,
    FunctionTypeContactService,
    ProgramFunctionContactService,
    ProgramAnalystService,
    ProgramTaskService,
    ProgramTaskDetailService,
    ProjectService,
    SystemService,
    ToolService,
    ToolChildrenService,
    ToolNumberService,
    ToolDescriptionService,
    PlantOccurrenceService,
    ParallelProcessService,
    KitService,
    KitDescriptionService,
    CellService,
    StationService,
    SystemSourceService,
    SystemEstimationLevelService,
    SourceService,
    SystemByProgramService,
    SystemStatusService,
    DateTemplateService,
    SystemPhaseService,
    FunctionalViewSystemPhaseService,
    SystemTimingControlDatesService,
    SystemPhaseDetailService,
    ControlPanelService,
    DateTemplateSystemPhaseService,
    ControlPanelServiceDescription,
    ToolTypeService,
    KitServiceDescription,
    SystemAllocationStatusService,
    ToolTypeDescriptionService,
    TimingChartControlService,
    WorkflowInboxService,
    WorkflowStartService,
    ReportService,

    ZoneFunctionContactService,
    SourceFunctionContactService,
    ProjectFunctionContactService,
    SourceContactService,
    ToolDescriptionByTypeService,
    ProgramTaskDetailById,
    FunctionTypeService,
    WorkflowApprovalService,
    WorkflowTaskService,
    RequestProcessService,
    ConstructionSourceService,
    IntegrationSourceService,
    ProductionSourceService,
} from './camtl.service';


@NgModule({
    imports: [
        SharedModule,
        CamtlMaintenanceModule,
        CamtlSecurityModule,
        CamtlReportsModule,
        CamtlContactsModule,
        CamtlMasterToolListModule,
        MatInputModule,
    ],
    declarations: [
        CamtlComponent,
        CamtlAdministrationComponent,
        SystemSelectComponent,
        TimingChartsComponent,
        FunctionalViewComponent,
        ParameterManagementComponent,
        ControlPanelComponent,
        FurnishedEquipmentComponent,
        KitComponent,
        ParameterTabsComponent,
        ToolComponent,
        WeldgunComponent,
        WorkflowInboxComponent,
        ApprovalComponent

    ],
    providers: [
        CamtlBaseService,
        ContactService,
        FunctionService,
        FunctionContactService,
        FunctionTypeContactService,
        ProgramFunctionContactService,
        ProgramAnalystService,
        ProgramTaskService,
        ProgramTaskDetailService,
        ProjectService,
        SystemService,
        FunctionalViewService,
        ToolService,
        ToolChildrenService,
        ToolNumberService,
        ToolDescriptionService,
        PlantOccurrenceService,
        SystemSelectService,
        SourceService,
        SystemByProgramService,
        ParallelProcessService,
        KitService,
        KitDescriptionService,
        CellService,
        StationService,
        SystemSourceService,
        SystemEstimationLevelService,
        DateTemplateService,
        SystemStatusService,
        DateTemplateService,
        SystemPhaseService,
        FunctionalViewSystemPhaseService,
        SystemTimingControlDatesService,
        ToolTypeService,
        ControlPanelService,
        SystemPhaseDetailService,
        DateTemplateSystemPhaseService,
        ControlPanelServiceDescription,
        KitServiceDescription,
        ToolTypeDescriptionService,
        ParameterManagementTypeService,
        ZoneFunctionContactService,
        SourceFunctionContactService,
        ProjectFunctionContactService,
        SourceContactService,
        ToolDescriptionByTypeService,
        SystemAllocationStatusService,
        ProgramTaskDetailById,
        TimingChartControlService,
        FunctionTypeService,
        WorkflowInboxService,
        WorkflowStartService,
        WorkflowApprovalService,
        RequestProcessService,
        WorkflowTaskService,
        ReportService,
        ConstructionSourceService,
        IntegrationSourceService,
        ProductionSourceService
    ]
})
export class CamtlModule { }
